import { ElementCategoryID } from '@shared/models/element-categories.model';
import {
  placementForNewElementSbefCode,
  SettableElementPropertyValues,
} from '@shared/helpers/element-property-values.helpers';
import { DEFAULT_SBEF_CUSTOM_GROUPS } from '@features/sbef/custom-groups.model';
import { getSbefGroupDropCode } from './sbef-group-drop.helpers';

/**
 * Add options for an element created from an SBEF group row.
 *
 * Seeds the group's code when a bare element of `categoryId` defines `sbef_code`,
 * so the row is created in that group. Undefined when the group has no code, or
 * when the category has no such row (Maintenance). The element then stays
 * ungrouped and lists under Site operations.
 */
export const newElementOptionsForSbefGroupAdd = (
  categoryId: ElementCategoryID,
  groupKey: string,
): { propertyValues: SettableElementPropertyValues } | undefined => {
  const groupSbefCode = getSbefGroupDropCode(
    groupKey,
    DEFAULT_SBEF_CUSTOM_GROUPS,
  );
  const { propertyValues } = placementForNewElementSbefCode(
    categoryId,
    groupSbefCode,
  );
  if (!propertyValues) return undefined;
  return { propertyValues };
};
